import IntercomClient from '../clients/shared/IntercomClient';
import BaseEnrollmentClient from '../clients/shared/EnrollmentClient';
import { FETCH_INTERCOM_INFO } from '../actionTypes/shared/apiActionTypes';
import { apiActionCreator } from '../actionCreators';

const fetchIntercomInfo = setUserHash => async dispatch => {
    const additionalApiParams = {
        preApiCallCalback: async () => {
            const userHash = await IntercomClient.getUserHash();
            setUserHash(userHash.key);
        },
    };
    await apiActionCreator(
        dispatch,
        FETCH_INTERCOM_INFO,
        BaseEnrollmentClient.getIntercomInfo,
        additionalApiParams,
    );
};

export default fetchIntercomInfo;
